import { isPhone } from '@seek/validators-js';
import type { FormValues, SpecialTextFormFields } from '../types.ts';

import { TextField as BraidTextField } from 'braid-design-system';
import { Controller, useFormContext } from 'react-hook-form';
import { parseLabel } from '../parseLabel.tsx';
import { useMemo } from 'react';

interface PhoneProps {
  element: SpecialTextFormFields;
}

export const Phone = ({ element }: PhoneProps) => {
  const { setValue } = useFormContext<FormValues>();
  const label = useMemo(
    () => parseLabel(element.id, element.label, element.labelLinks),
    [element.id, element.label, element.labelLinks],
  );
  return (
    <Controller
      key={element.id}
      name={element.id}
      rules={{
        required: element.required ? 'This field is required' : false,
        validate: element.required
          ? {
              validPhone: (value) =>
                isPhone.test({
                  value,

                  validatorProps: undefined,
                  formValues: undefined,
                })
                  ? true
                  : 'Invalid phone number',
            }
          : undefined,
      }}
      render={({ field, fieldState }) => (
        <BraidTextField
          label={label}
          placeholder={element.placeholder}
          secondaryLabel={element.secondaryLabel}
          onChange={field.onChange}
          type="tel"
          value={field.value}
          message={fieldState.error?.message}
          tone={fieldState.invalid ? 'critical' : undefined}
          onClear={() => setValue(element.id, '')}
        />
      )}
    />
  );
};
